var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language"},[_c('p',[_c('router-link',{attrs:{"to":_vm.path,"data-hover":"link"}},[_vm._v(_vm._s(_vm.locale === 'it' ? 'English Version' : 'Versione Italiana'))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }